(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[272],{

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 40685:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[pageSlug]",
      function () {
        return __webpack_require__(29840);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./store/index.ts + 15 modules
var store = __webpack_require__(96220);
// EXTERNAL MODULE: ./services/actionsArray.ts
var actionsArray = __webpack_require__(84189);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/site/SiteCustomPage.tsx









var PageHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4792), __webpack_require__.e(3997), __webpack_require__.e(4465)]).then(__webpack_require__.bind(__webpack_require__, 64465));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64465)
            ];
        }
    }
});
var Content = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4792), __webpack_require__.e(5675), __webpack_require__.e(5063), __webpack_require__.e(5372)]).then(__webpack_require__.bind(__webpack_require__, 65372));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65372)
            ];
        }
    }
});
function SiteCustomPage(props) {
    var ref;
    var pageSlug = props.pageSlug, domain = props.domain, dbName = props.dbName;
    var ref1 = (0,react.useState)(props === null || props === void 0 ? void 0 : props.content), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react.useState)(false), isTable = ref2[0], setIsTable = ref2[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (pageSlug) {
            setContent(props === null || props === void 0 ? void 0 : props.content);
        }
    }, [
        pageSlug,
        router.locale
    ]);
    (0,react.useEffect)(function() {
        if (content) {
            var text = document.getElementsByTagName("table");
            text && text[0] ? setIsTable(true) : setIsTable(false);
        }
    }, []);
    var schemaPages = {
        "@context": "https://schema.org/",
        "@type": "Page",
        name: "Pages",
        offers: [],
        url: (0,helper/* domainUrl */.HJ)(dbName + router.asPath)
    };
    var breadcrumb = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "home",
                defaultMessage: "Home"
            }),
            url: "https://".concat(dbName, "/")
        },
        {
            title: (ref = content === null || content === void 0 ? void 0 : content.data[0]) === null || ref === void 0 ? void 0 : ref.page_title,
            url: ""
        }
    ];
    var logoPath = "/stores-logo.svg";
    var metaData = content === null || content === void 0 ? void 0 : content.data[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schemaPages)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader, {
                        header: breadcrumb[1].title,
                        breadcrumb: breadcrumb
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        text: content
                    }, props), {
                        isTable: isTable,
                        domain: props.domain,
                        dbName: props.dbName
                    }))
                ]
            })
        ]
    });
}
/* harmony default export */ var site_SiteCustomPage = (SiteCustomPage);

// EXTERNAL MODULE: ./components/MetaWrapper.tsx
var MetaWrapper = __webpack_require__(28496);
;// CONCATENATED MODULE: ./pages/page/[pageSlug].tsx













var __N_SSP = true;
function Page(props) {
    var locale = props.locale, dbName = props.dbName, dispatches = props.dispatches, metas = props.metas, content = props.content, domain = props.domain;
    var _ref = (0,next_router.useRouter)(), query = _ref.query, router = (0,_object_without_properties/* default */.Z)(_ref, [
        "query"
    ]);
    var dispatch = store/* default.dispatch */.Z.dispatch;
    var ref = content || {}, tmp = ref.yoast, ref1 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref1[0], ref2 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref2.yoast_facebook_description, FB_desc = tmp2 === void 0 ? null : tmp2, tmp3 = ref2.yoast_facebook_title, FB_title = tmp3 === void 0 ? null : tmp3, tmp4 = ref2.yoast_twitter_description, TW_desc = tmp4 === void 0 ? null : tmp4, tmp5 = ref2.yoast_twitter_title, TW_title = tmp5 === void 0 ? null : tmp5, tmp6 = ref2.yoast_focus_keyword, y_keyword = tmp6 === void 0 ? null : tmp6, tmp7 = ref.data, ref3 = (0,_sliced_to_array/* default */.Z)(tmp7 === void 0 ? [] : tmp7, 1), tmp8 = ref3[0], ref4 = tmp8 === void 0 ? {} : tmp8, tmp9 = ref4.meta_title, m_title = tmp9 === void 0 ? content.data[0].page_title : tmp9, tmp10 = ref4.meta_description, m_desc = tmp10 === void 0 ? "" : tmp10, tmp11 = ref4.meta_keywords, m_keyword = tmp11 === void 0 ? "" : tmp11, tmp12 = ref4.image, m_img = tmp12 === void 0 ? "" : tmp12;
    (0,react.useEffect)(function() {
        window.history.replaceState(null, "", window.location.pathname);
    }, [
        query.pageSlug,
        locale
    ]);
    (0,react.useEffect)(function() {
        window.onpopstate = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            router.push(window.location.pathname)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        query.pageSlug,
        locale,
        router.route,
        router
    ]);
    (0,react.useEffect)(function() {
        for(var actionKey in dispatches){
            // @ts-ignore
            dispatch(actionsArray/* default */.Z[actionKey](dispatches[actionKey]));
        }
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaWrapper/* MetaWrapper */.Q, {
        title: !!m_title ? m_title : content.data[0].page_title,
        m_desc: m_desc,
        m_url: (0,helper/* domainUrl */.HJ)(dbName + "/" + locale + router.asPath),
        m_img: !!m_img ? "".concat(domain, "/").concat(m_img) : undefined,
        m_key: m_keyword,
        TW_desc: TW_desc,
        FB_desc: FB_desc,
        TW_title: TW_title,
        FB_title: FB_title,
        y_keyword: y_keyword,
        locale: locale,
        domain: domain,
        dbName: dbName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site_SiteCustomPage, (0,_object_spread/* default */.Z)({
            pageSlug: query.pageSlug
        }, props))
    });
}


/***/ }),

/***/ 84189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _store_general__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26298);
/* harmony import */ var _store_token__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46607);
/* harmony import */ var _store_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10668);
/* harmony import */ var _store_locale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98410);
/* harmony import */ var _store_rate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38691);





/* harmony default export */ __webpack_exports__["Z"] = ({
    setDomain: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setDomain */ .W9,
    setSocial: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setSocial */ .It,
    setFbPixel: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setFbPixel */ .XX,
    setPopup: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setPopup */ .ZA,
    setRate: _store_rate__WEBPACK_IMPORTED_MODULE_4__/* .setRate */ .FY,
    setCustomJs: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCustomJs */ .ie,
    setBackorders: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setBackorders */ .G_,
    setCacheVersion: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCacheVersion */ .uN,
    setCoreConfigs: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCoreConfigs */ .ly,
    setTranslations: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setTranslations */ .Yh,
    AddCartToken: _store_token__WEBPACK_IMPORTED_MODULE_1__/* .AddCartToken */ .y,
    changeCurrency: _store_currency__WEBPACK_IMPORTED_MODULE_2__/* .changeCurrency */ .sy,
    setCurrencies: _store_currency__WEBPACK_IMPORTED_MODULE_2__/* .setCurrencies */ .HC,
    setLocaleList: _store_locale__WEBPACK_IMPORTED_MODULE_3__/* .setLocaleList */ .p4,
    changeLocale: _store_locale__WEBPACK_IMPORTED_MODULE_3__/* .changeLocale */ .wo,
    setMenuList: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setMenuList */ .kT,
    setCategories: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCategories */ .DG,
    setInitialMinPrice: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setInitialMinPrice */ .E8,
    setInitialMaxPrice: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setInitialMaxPrice */ .lm
});


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6764,4012,8366,6002,9774,2888,179], function() { return __webpack_exec__(40685); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);